import { httpClient } from '@/services/http/httpClient'

type CreateHistoryAttachmentProps = {
  ideaId: string
}

export const createHistoryAttachment = async ({
  ideaId,
}: CreateHistoryAttachmentProps) => {
  const response = await httpClient.post(
    `/ideas/ideas/${ideaId}/history-attachments`,
  )

  return response.data
}
